import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="timer-toggle"
// Handles showing/hiding the timer display
export default class extends Controller {
  click(event) {
    event.preventDefault()

    const $ = window.$
    if (!$) {
      console.warn('[timer-toggle] jQuery not available')
      return
    }

    const showAttr = $(".interface-timer-yash").attr("data-show")

    // If time is showing (data-show == 1), hide it
    if (showAttr == "1") {
      $("#stopwatch-yash").addClass("interface-timer-hide-yash")
      $(".interface-progress-bar-yash").addClass("interface-timer-hide-yash")
      $(".interface-timer-yash").attr("data-show", "0")
    } else {
      // Otherwise, show it
      $("#stopwatch-yash").removeClass("interface-timer-hide-yash")
      $(".interface-progress-bar-yash").removeClass("interface-timer-hide-yash")
      $(".interface-timer-yash").attr("data-show", "1")
    }
  }
}

